import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import * as S from "./styles";
/**
 * Cart header to use with conjunction of cart rows.
 */

var CartHeader = function CartHeader() {
  var intl = useIntl();
  return React.createElement(S.Wrapper, null, React.createElement(S.Column, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Products",
    "id": "@next.components.atoms.CartHeader.CartHeader.2968663655"
  }, "id", "@next.components.atoms.CartHeader.CartHeader.2968663655"))), React.createElement(S.Column, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Price",
    "id": "@next.components.atoms.CartHeader.CartHeader.1134347598"
  }, "id", "@next.components.atoms.CartHeader.CartHeader.1134347598"))), React.createElement(S.Column, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Quantity",
    "id": "@next.components.atoms.CartHeader.CartHeader.2796503714"
  }, "id", "@next.components.atoms.CartHeader.CartHeader.2796503714"))), React.createElement(S.Column, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Total Price",
    "id": "@next.components.atoms.CartHeader.CartHeader.216202846"
  }, "id", "@next.components.atoms.CartHeader.CartHeader.216202846"))));
};

export { CartHeader };